import { render, staticRenderFns } from "./vendorInvoices.vue?vue&type=template&id=53f403c2&scoped=true&"
import script from "./vendorInvoices.vue?vue&type=script&lang=js&"
export * from "./vendorInvoices.vue?vue&type=script&lang=js&"
import style0 from "./vendorInvoices.vue?vue&type=style&index=0&id=53f403c2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f403c2",
  null
  
)

export default component.exports